// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CommentReply_wrapper","content":"CommentReply_content","submit":"CommentReply_submit","active":"CommentReply_active","cancel":"CommentReply_cancel"};